module.exports = __webpack_public_path__ + "static/media/img_howto_phone_illust1_1@3x.1cabee38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_howto_phone_illust1_1@3x.png
// module id = 1097
// module chunks = 0